/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Pit3_TInputs */

const en_csv_to_json_pit3_t = /** @type {(inputs: Csv_To_Json_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A duplicate header name silently wins`)
};

const ko_csv_to_json_pit3_t = /** @type {(inputs: Csv_To_Json_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중복된 헤더 이름은 조용히 승부가 납니다`)
};

const ja_csv_to_json_pit3_t = /** @type {(inputs: Csv_To_Json_Pit3_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複したヘッダ名は静かに決着します`)
};

/**
* | output |
* | --- |
* | "A duplicate header name silently wins" |
*
* @param {Csv_To_Json_Pit3_TInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_pit3_t = /** @type {((inputs?: Csv_To_Json_Pit3_TInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Pit3_TInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_pit3_t(inputs)
	if (locale === "ko") return ko_csv_to_json_pit3_t(inputs)
	return ja_csv_to_json_pit3_t(inputs)
});